export const allowOnlyDateCharacters = (event: KeyboardEvent): void => {
  const allowedChars = /[0-9/]/;
  const inputChar = String.fromCharCode(event.keyCode || event.which);

  if (!allowedChars.test(inputChar)) {
    event.preventDefault();
  }
};
